import React from "react";
import Loading from "./Loading";
import NoData from "./NoData";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

/**
 * Componente generico que implementa una grilla paginada.
 *
 * @param {*} props
 */
export default class Table extends React.Component {
  /**
   * @constructor
   * @param {*} props
   */
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      currentPage: 1,
      sizePerPage: 25,
      totalDataSize: 0,
      sortName: "id",
      sortOrder: "desc",
      columns: props.columns
    };
    this.bind();
  }

  /**
   * Se encarga de bindear los metodos
   */
  bind() {
    this.renderElements = this.renderElements.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
  }

  /**
   * Cuando el componente se monta se setea la referencia y se dispara el load inicial.
   */
  componentWillMount() {
    this.props.onRef(this);
    let filters = this.props.filters ? this.props.filters : {};
    let args = {};
    for (var key in filters) {
      args[`by_${key}`] = filters[key];
    }
    this.load(args);
  }

  /**
   * Este método se encarga de disparar el request que se encarga de
   * recuperar los datos del servidor.
   *
   * @param {object} filters contiene los datos de filtrado y paginación.
   * @param {number} [page] número de página, por defecto toma el valor actual.
   */
  load(filters, page) {
    page = page ? page : this.state.currentPage;
    let sortName = filters.sortName ? filters.sortName : this.state.sortName;
    let sortOrder = filters.sortOrder
      ? filters.sortOrder
      : this.state.sortOrder;
    delete filters.sortName;
    delete filters.sortOrder;

    let defaultFilter = {
      pageSize: this.state.sizePerPage,
      page: 0,
      [`orderBy_${sortName}`]: sortOrder
    };
    filters = Object.assign(defaultFilter, filters);
    this.props.api
      .listar(filters)
      .then(response => {
        this.setState({
          filters: filters,
          data: response.data.rows.map(value => ({
            ...value,
            format: this.strongFormatter
          })),
          totalDataSize: response.data.count,
          page: page
        });
      })
      .catch(err => {
        console.log("error");
      });
  }

  /**
   * Cuando cambia los parametros de ordenado.
   * @param {*} sortName
   * @param {*} sortOrder
   */
  onSortChange(sortName, sortOrder) {
    this.setState({
      sortName,
      sortOrder
    });
    this.load({
      sortName: sortName,
      sortOrder: sortOrder
    });
  }
  /**
   * Callback al cambiar la página
   */
  onPageChange(page, sizePerPage) {
    const currentIndex = (page - 1) * sizePerPage;
    this.load(
      {
        pageSize: sizePerPage,
        start: currentIndex,
        page: page
      },
      page
    );
  }

  /**
   * Se encarga de renderizar la tabla.
   */
  renderElements() {
    if (this.state.loading) {
      return <Loading />;
    }
    const {
      sizePerPage,
      totalDataSize,
      currentPage,
      data,
      columns
    } = this.state;
    return (
      <BootstrapTable
        striped
        hover
        remote={true}
        pagination={true}
        fetchInfo={{ dataTotalSize: totalDataSize }}
        data={data}
        pagination={this.props.pagination}
        options={{
          prePage: "<", // Previous page button text
          nextPage: ">", // Next page button text
          page: currentPage,
          sizePerPage: sizePerPage,
          onPageChange: this.onPageChange,
          noDataText: <NoData />,
          onSortChange: this.onSortChange
        }}
      >
        {columns.map(head => {
          if (head.isKey) {
            return (
              <TableHeaderColumn
                isKey
                dataField={head.key}
                key={head.key}
                hidden={head.hidden}
                dataSort={typeof head.sort == "undefined" ? true : head.sort}
              >
                {head.title}
              </TableHeaderColumn>
            );
          }
          return (
            <TableHeaderColumn
              dataField={head.key}
              key={head.key}
              dataFormat={head.format}
              dataSort={typeof head.sort == "undefined" ? true : head.sort}
            >
              {head.title}
            </TableHeaderColumn>
          );
        })}
      </BootstrapTable>
    );
  }

  /**
   * Renderiza el componente.
   */
  render() {
    return this.renderElements();
  }
}
